import { Col, Row } from "antd";
import React from "react";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import CustomButton from "./CustomButton";
import { StopOutlined } from "@ant-design/icons";
import "./DryingView.css";
import DryingPageStateTable from "./DryingPageStateTable";
import PressureGauge from "./Gauges/PressureGauge";
import MoistureGauge from "./Gauges/MoistureGauge";
import TemperatureGauge from "./Gauges/TemperatureGauge";
import TapestripTable, { useDayTick } from "./TapestripTable";

interface DryingViewProps{
    binDto: PremierPlusBinDTO | null | undefined;
}

const DryingView : React.FC<DryingViewProps> = ({ binDto }) => {

    return(
    <>
        <DryingPageStateTable binDto={binDto}/>

        <Row gutter={4} style={{ paddingRight:'16px'}}>  
            <Col span={6}>
                <PressureGauge label={"Static Pressure"} pressure={binDto?.fans?.[0]?.plenumPressure}/>
            </Col>
                  
            <Col span={6}>
                <MoistureGauge label={"Ind. Moisture"} moisture={binDto?.dryingOperation?.lastSampleMc}/>
            </Col>

            <Col span={6}>
                <MoistureGauge label={"Moist. Avg"} moisture={binDto?.dryingOperation?.averageSampleMc}/>
            </Col>
                  
            <Col span={6}>
                <TemperatureGauge 
                useCelsius={false} 
                label={"Plenum Temp"} 
                temperature={binDto?.dryingOperation?.averagePlenumTemperatureF}/>
            </Col> 
        </Row>

        <TapestripTable binDto={binDto} inModal={false} maxTapestrips={50} />

        <Row gutter={16} style={{ padding:'8px', justifyContent: "center" }}>

            <Col>
                <CustomButton 
                label={'Sequenced Stop'} 
                variant='danger'
                disabled={true}
                />
            </Col>

            <Col>
                <CustomButton 
                label={'Stop All'} 
                variant='danger' 
                icon={<StopOutlined/>}
                disabled={true}
                />
            </Col>

            <Col>
                <CustomButton 
                label={'Sample'} 
                variant='tertiary'
                disabled={true}
                />
            </Col>

            <Col>
                <CustomButton 
                label={'Settings'}
                disabled={true}
                />
            </Col>
        </Row>
    </>
    )
}

export default DryingView;